export const noPreview =
`Previews are not available for this type of file.
 Click the "Download Now" button located above to get all of the materials and view this file on your machine.`;
export const notLoggedIn = 'Please log in to preview this file.';
